document.addEventListener("DOMContentLoaded", function () {

  // Sticky header
  window.addEventListener("scroll", () => {
    const header = document.querySelector(".main_header");
    header?.classList.toggle("fixed", window.scrollY > 30);
  });

  // Accordion
  $(".ingrdtnt-card h4").click(function(){
    $(this).toggleClass("active");
    $(this).siblings(".metafield-rich_text_field").slideToggle();
    $("body").toggleClass("ingredient_open");
  });

  $(".ingrdn_closebtn").click(function(e){
    e.stopPropagation();
    const card = $(this).closest(".ingrdtnt-card");
    card.find(".metafield-rich_text_field").slideUp();
    card.find("h4").removeClass("active");
    $("body").removeClass("ingredient_open");
  });

  $("button.filter-bar__button span").click(function(){
    $("body").toggleClass("filteropen");
  });

  // Responsive wave
  function changeWave() {
    document.querySelectorAll(".def_col_wave svg").forEach(el => {
      el.setAttribute("viewBox", window.innerWidth < 500 ? "0 0 1040 320" : "0 0 1440 320");
    });
  }
  window.addEventListener("resize", changeWave);
  changeWave(); // run once on load

  // Swiper slider
  new Swiper(".leadershipslider", {
    slidesPerView: 3,
    spaceBetween: 30,
    pagination: { el: ".swiper-pagination", clickable: true },
    breakpoints: {
      640: { slidesPerView: 1.5, spaceBetween: 20 },
      768: { slidesPerView: 2.5, spaceBetween: 30 },
      992: { slidesPerView: 2.5, spaceBetween: 40 },
      1200: { slidesPerView: 3, spaceBetween: 40 },
      1400: { slidesPerView: 3, spaceBetween: 40 },
    },
  });

});






// navbar responsive close functionality 

let desktopObserver = window.matchMedia("(min-width: 992px)");

function resetnavbar() {
  const drawerMenu = document.getElementById("side_menu");
  const sideMenuBtn = document.getElementById("sideMenuBtn");
  if (drawerMenu.classList.contains("active")) {
    drawerMenu.classList.remove("active");
    sideMenuBtn.setAttribute('aria-expanded',"false")
    sideMenuBtn.setAttribute('aria-label',"Close menu modal")
  }
}

desktopObserver.addEventListener("change", resetnavbar);


resetnavbar();

document.querySelectorAll('.quantity-input__input').forEach(input => {
    input.addEventListener('keydown', function (e) {
        if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
            e.preventDefault();
        }
    });
});


